/**@jsx jsx */
import React from "react";
import { Flex, jsx } from "theme-ui";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Sidebar from "../components/Sidebar";

interface LayoutProps {
	children: React.ReactNode;
	stsLayout?: boolean;
}

const DefaultLayout = ({ children, stsLayout }: LayoutProps) => {
	return (
		<div sx={{ background: "brand.lightGray" }}>
			<Flex
				sx={{
					flexDirection: "column",
					minHeight: "100vh",
					maxWidth: "1920px",
					mx: "auto",
				}}
			>
				<Navbar stsLayout={stsLayout} />
				<Sidebar />
				<main>{children}</main>
				<Footer />
			</Flex>
		</div>
	);
};

export default DefaultLayout;
